import React, { useState, useEffect, useRef } from "react";
import { sbaAxios } from "../../utils/sbaAxios";
import { TopBar } from "../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { DateRangePicker } from "rsuite";
import moment from "moment";
import { SBAComboBox } from "../../UiComponents/SBADropDown";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer, toast } from 'react-toastify';
import { Modal } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import {getAdminClassificationItems,getClassificatioParents,insertOrupdateClassification}from "../../../config/apiConfig";
export const Classfications = () => {
    const [render, setRender] = useState(true);
    const [griddata, setGriddata] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [selectedcategoryData, setselectedcategoryData] = useState([]);
    const [show, setshow] = useState(false);
    const [classificationCategory, setclassificationCategory] = useState([]);
    const [sortOrder, setsortOrder] = useState([]);
    const [fullName, setFullName] = useState(false);
    const [shortName, setshortName] = useState([]);
    const [classificationId, setClassificationId] = useState(0);
    const [isDisabled, setIsDisabled] = React.useState(true);
    const [deleteModal,setDeleteModal]=useState(false);
    let Level = [{ BreadCrumb: "Admin > ", Routes: `${UrlPath.Admin}` }];

    Level = render ? Level : [...Level,{ BreadCrumb: `Classfications`, Routes: `${UrlPath.Classfications}`,},];

    useEffect(() => {
        document.title = `Classfications`;
          setRender(false);
          getClassifications();
      
      }, []);
     // get Classification-Dropdown
     const getClassifications = () => {
        sbaAxios({ url: getClassificatioParents }).then(res => {
            setCategoryData(res);
            setselectedcategoryData(res[0])
            getClassificationItems(res[0].ClassificationId)
        }).catch(e => {
            console.log(e, 'Error Loading the Application settings Data');
            setCategoryData([]);
        })
    };
    // get  Grid Data 
    const getClassificationItems = async (parentClassificationId) => {
        
        try {
            const response = await sbaAxios({
                url: `${getAdminClassificationItems}/${parentClassificationId}`,
                method: 'get',
            });
            if (response) {
                setGriddata(response);
            }
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')
        };
    };
    const ActionRenderer = (props) => {        
        
        const handleEditClick = () => {       
            setshow(true);
          setclassificationCategory(selectedcategoryData.ClassificationLongName)
          setFullName(props.data.ClassificationLongName);
          setshortName(props.data.ClassificationShortName);
          setsortOrder(props.data.SortOrder);
          setClassificationId(props.data.ClassificationId)
        };
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-edit"
                    style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleEditClick}
                ></i>
            </div>                        
        );
    }; 
    const deleteActionRenderer = () => {        
        const handleDeleteClick = () => {       
            setDeleteModal(true);
        };
        return (
            <div className="actions-cell">
                <i
                    className="fa fa-trash"
                    style={{
                        color: isDisabled ? "grey" : "red",
                        margin: "0 8px",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        pointerEvents: isDisabled ? "none" : "auto"
                    }}
                    onClick={isDisabled ? null : handleDeleteClick}
                >
                </i>
            </div>                        
        );
    }; 
    const categoryCmbChange = (e) => {
    
        if (e.value)
        {
            getClassificationItems(e.value.ClassificationId);
        
            setselectedcategoryData(e.value);
        }   
       };
    var coldef = [
        {
            field: "ClassificationShortName",
            headerName: "Short Name",
        },
        {
            field: "ClassificationLongName",
            headerName: "Full Name",

        },
        {
            field: "SortOrder",
            headerName: "Sort Order",
            width: 100,
            minWidth: 50,
            maxWidth: 150
           
        },
        {
            field: "",
            headerName: "Edit",
            cellRenderer: ActionRenderer,
            width: 100, 
            minWidth: 50,
            maxWidth: 150
           
        },
        {
            field: "",
            headerName: "Delete",
            cellRenderer: deleteActionRenderer,
            width: 100, 
            minWidth: 50,
            maxWidth: 150,
           
        },

    ];
    const defaultColDef = {
        sortable: true, filter: true, floatingFilter: true, flex: 1, filter: 'agTextColumnFilter',resizable:true
    }
    const AddClassifications = () => {       
          setshow(true);
          setclassificationCategory(selectedcategoryData.ClassificationLongName)
          setFullName();
          setshortName();
          setsortOrder();
          setClassificationId(0);
    };

       // Application Setting save data
       const SaveClassificationItems = () => {      
        let ifsave = true;
        const savedata = 
            {
                "classificationId": classificationId,
                "parentClassificationId": selectedcategoryData.ClassificationId,
                "sortOrder": sortOrder,
                "classificationShortName": shortName,
                "classificationName":fullName
              }
       
        if (!fullName) {
            ifsave = false;
            SBNotify({ Msg: " Please Enter FullName ", type: "error" });
        }
        
        if (ifsave) {

            sbaAxios({
                url: `${insertOrupdateClassification}`,
                method: "post",
                data: savedata
            }).then((res) => {             
                if (res !== -1000 && res !== -2000)
                {
                    if (classificationId === 0) {
                        SBNotify({
                            Msg: "Classification Save Successfully",
                            type: "success",
                        });
                    }

                    else {
                        SBNotify({
                            Msg: "Classification Updated Successfully",
                            type: "success",
                        });
                    }
               
                    setshow(false);
                    getClassificationItems(selectedcategoryData.ClassificationId);
                }
                else if ( res === -1000) {
                    SBNotify({
                        Msg: "Classification SortOrder Already exists",
                        type: "error"
                    });
                }
                else if ( res === -2000) {
                    SBNotify({
                        Msg: "Classification Name Already exists",
                        type: "error"
                    });
                }       
                   
            })
                .catch((error) => {
                    SBNotify({ Msg: error, type: "error" });
                });
        }
    };
    return (
        <>
         {/* <TopBar label={"Classifications"} />
          <div className="mainContentData">
            <BreadCrumbs Levels={Level} /> */}
            <div className="">
              <div className="bg-white p-3 border rounded">
                <div className="d-flex">
                    <div className="mb-4 col-3">                                 
                      <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Classification Category</label>
                                      <div>
                                        <SBAComboBox
                                          className="w-100"  
                                          data={categoryData}
                                     value={selectedcategoryData}
                                      textField={"ClassificationLongName"}
                                      valueField={"ClassificationId"}
                                      onChange={categoryCmbChange}
                                          />                                      
                                    </div>                  
                    </div>
                             
                          </div>
                          <div className="ag-theme-alpine m-1 " style={{ width: '100%', height: '500px' }}>
                          <AgGridReact
                               columnDefs={coldef}
                               rowData={griddata}
                               defaultColDef={defaultColDef}
                          />
                          </div>
                          <div
                className="m-5 d-flex justify-content-end"
              >
              <button className="ms-2 p-sm-btn"
                  onClick={() => { AddClassifications() }}
                >
                  Add
                </button>
                </div>
                      </div>
                  </div>
                  <SBADrawer
                  open={show}
                  setOpen={setshow}
                  close={false}
                  title={"Insert/Edit Classsification"}
              >
                  <div className="drawer">
                      <div>
                          <div className="col-lg-12 px-0">
                              <div className="row m-2">
                                  <div className="row mb-4">                                   
                                      <div className="col-md-5">
                                          <label className="mb-1 label">Classfication Category</label>
                                          <div>
                                         
                                                  <input
                                                   className="form-control w-100"
                                                   type="text"
                                                  value={classificationCategory}
                                                  disabled
                                                  />
                                              
                                          </div>
                                      </div>
                                      <div className="col-md-5">
                                          <label className="mb-1 label">Sort Order</label>
                                          <div>
                                              <input
                                                  className="form-control w-100"
                                                  type="text"
                                                  value={sortOrder}
                                                  onChange={(e) => setsortOrder(e.target.value)}
                                              />
                                          </div>
                                      </div>
                                  </div>
                                  <div className="row mb-4">
                                      <div className="col-md-5">
                                      <label className="mb-1 label">Full Name<span class="mandatory">*</span></label>
                                          <div>
                                              <input
                                                  className="form-control w-100"
                                                  type="text"
                                                  value={fullName}
                                                  onChange={(e) => setFullName(e.target.value)}
                                              />
                                          </div>
                                      </div>
                                      <div className="col-md-5">
                                      <label className="mb-1 label">Short Name</label>
                                          <div>
                                              <input
                                                  className="form-control w-100"
                                                  type="text"
                                                  value={shortName}
                                                  onChange={(e) => setshortName(e.target.value)}
                                              />
                                          </div>
                                      </div>
                                  </div>

                              </div>
                          </div>
                          <div className="mt-5">

                              <button className="p-sm-btn mx-1" onClick={SaveClassificationItems} >
                                  Save
                               </button>
                              <button className="s-sm-btn mx-1" onClick={() => {
                                  setshow(false);
                              }}>
                                  Cancel
                            </button>
                              
                          </div>
                      </div>
                  </div>
              </SBADrawer>
           {/* Delete Modal Popup */}
           <Modal show={deleteModal}>
      <Modal.Header
        closeButton
        onClick={() => {
          setDeleteModal(false);
        }}
      >
        <Modal.Title>Do you want to delete the selected Classification?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Classification will be deleted permanently. Are you sure?</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="s-sm-btn mx-1"
          onClick={() => {
            setDeleteModal(false);
          }}
        >
          Cancel
        </button>
        <button
          className="p-sm-btn mx-1" 
        >
          Yes
        </button>
      </Modal.Footer>
    </Modal>
             {/* <ToastContainer></ToastContainer> */}
          {/* </div> */}
        </>
      );
}